<template>
  <div class="wapper">
    <div class="logoDiv">
      <img class="logo"
         :src="require(`../assets/${$platform}_logo.png`)"
         alt="logo" v-if="!channelInfo.logoUrl">
      <img class="logo"
         :src="channelInfo.logoUrl"
         alt="logo" v-if="channelInfo.logoUrl">
        <p v-if="isChannel" class="channel">|&nbsp;{{channelInfo.channelName}}业务管理系统</p>
    </div>
    <div class="content-wapper">
      <div class="login-wapper">
        <div class="login-title"
             v-show="loginText.type != 'qrCode'" v-if="!isChannel">
          {{loginText.title}}
        </div>
        <div class="login-title" v-if="isChannel">
          用户登录
        </div>
        <div class="login-content"
             v-show="loginText.type != 'qrCode'">
          <input type="text"
                 :placeholder="loginText.inputText"
                 v-model="account"
                 @keyup.enter="submit">
          <input type="password"
                 placeholder="密码"
                 v-model="passWord"
                 @keyup.enter="submit">
          <span class="error-message">{{errorMessage}}</span>
          <a href="javascript:void(0);"
             class="btn"
             @click="submit">登录</a>
          <a href="javascript:;"
             class="link-a"
             @click="retrievePassword" v-if="!isChannel">忘记密码?</a>
        </div>

        <div id="qr-code"
             class="qr-code"
             v-show="loginText.type== 'qrCode'"></div>

        <div class="login-footer">
          <template v-for="item,index in loginTypes">
            <a href="javascript:void(0);"
               v-if="item.platform_filter.indexOf($platform) < 0 && !isChannel"
               :key="index"
               @click="cutLoginType(item)">{{item.title}}</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _userinfo from '@/service/userinfo-service'
import _cookies from 'js-cookie'
import _constant from '@/utils/constant'
import _request from '@/utils/request.js'
import _channel from '../service/channel-service'
import { Notification,MessageBox,Loading } from 'element-ui'
export default {
  data () {
    return {
      loginText: {
        type: this.$platform == 'fulufuxi' ? 'phone' : 'qrCode',
        title: this.$platform == 'fulufuxi' ? '手机号/账号登录' : '',
        inputText: this.$platform == 'fulufuxi' ? '手机号/账号' : '',
      },
      loginTypes: [
        {
          type: 'qrCode',
          title: '扫码登录',
          inputText: '',
          platform_filter: ['fulufuxi']
        },
        {
          type: 'phone',
          title: '手机号/账号登录',
          inputText: '手机号/账号',
          platform_filter: []
        }
      ],
      errorMessage: null,
      // 登录信息
      account: null,
      isChannel:false,
      channelInfo:{
        channelName:null,
        logoUrl: null
      },
      channelLoginCode:this.$route.query.channelLoginCode,
      passWord: null
    }
  },
  mounted() {
    if(this.channelLoginCode) {
      if(this.channelLoginCode && this.channelLoginCode != 'QD0000') {
        this.loginText.type = 'phone'
        this.loginText.inputText = '手机号/账号'
      }
      _channel.getChannelInfo({ channelLoginCode: this.channelLoginCode }, res => {
        this.channelInfo = res
        if (this.channelLoginCode != 'QD0000') {
          this.isChannel = true
        }
      }, res => {
        this.errorMessage = res
        Notification({
          message: res + '---请核对登录地址中的渠道标识是否正确',
          type: 'warning'
        })
      })
    }
    window.WwLogin({
      "id": "qr-code",
      "appid": _request.appid,
      "agentid": _request.agentid,
      "redirect_uri": _request.passport_address + "/authorize",
      "href": "https://rs.juyoufuli.com/static/passport/wechat_qr_code.css?v=20200612"
    })
  },
  methods: {
    retrievePassword () {
      window.location.replace(_request.general_address + '/send-retrieve-password')
    },
    cutLoginType (type) {
      this.loginText = type
      this.loginTypes.forEach(item => {
        item.isShow = true
      })
      type.isShow = false
    },
    submit () {
      if (this.account == null || this.account == '') {
        this.errorMessage = '手机号/账号不能为空'
        return
      }
      // 参数验证
      if (this.passWord == null || this.passWord == '') {
        this.errorMessage = '密码不能为空'
        return
      }
      _userinfo.loginByPhoneOrAccount({
                channelLoginCode: this.channelLoginCode,
                phoneAccount: this.account,
                passWord: this.passWord
            }, response => {
        _cookies.set(_constant.loginKey, response,
          {
            domain: _request.domain,
            expires: new Date(new Date().getTime() + 12 * 60 * 60 * 1000)
          })
        // 登录成功
        this.$router.push({
          path: '/',
          query:{
            channelLoginCode:this.channelLoginCode
          }
        })
      }, response => {
        this.errorMessage = response
      })
    }
  }
}
</script>

<style scoped>
.logo {
  width: 120px;
  height: 30px;
  position: absolute;
  top: 15px;
  left: 15px;
}
.wapper {
  width: 100%;
  height: 100%;
  background-image: url(../assets/background.jpg);
  background-repeat: no-repeat;
  background-position: bottom left;
}
.content-wapper {
  width: 350px;
  background: #fff;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  position: fixed;
  top: 180px;
  right: 180px;
  border: 1px solid #bcbcbc;
}
.login-title {
  margin: 0;
  padding: 30px 28px 43px 28px;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
}
.login-content {
  padding: 0 40px;
}
.content-wapper input {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  padding: 14px 10px;
  font-size: 14px;
  border: 1px solid #c9c9c9;
  border-radius: 2px;
  outline: none;
  height: 48px;
  margin-bottom: 15px;
}
.content-wapper .btn {
  border: none;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  background: #2984ef;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  padding: 8px;
  border-radius: 2px;
  margin-top: 15px;
}
.link-a {
  color: #2984ef;
  display: block;
  padding: 10px 0;
}
.login-footer {
  margin-top: 30px;
  padding: 16px;
  padding: 14px 0;
  border-top: solid 1px #ebeff2;
  font-size: 0;
  position: relative;
}
.login-footer a {
  font-size: 14px;
  color: #2b2b2b;
  text-align: center;
  display: inline-block;
  width: 50%;
}
.error-message {
  color: #f56c6c;
}
.qr-code {
  padding-top: 24px;
  padding-left: 26px;
  height: 320px;
}

.channel {
  position: absolute;
  left: 150px;top: 10px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 900;
}
</style>